// extracted by mini-css-extract-plugin
module.exports = {"radio":"ww7zJ","value":"WM-Nw","label":"Axusd","input":"Ycp+S","radio_mobile":"JikZo","label_theme_right":"ZWXrp","label_mobile":"_8by99"};